
import React, { Component } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';

import { desktopStandardDropdownStyle, desktopStandardDropdownMenuItemStyle } from './styles/desktop';
import { mobileStandardDropdownStyle, mobileStandardDropdownMenuItemStyle } from './styles/mobile';


const styles = theme => ({
    root: theme.mixins.gutters({
        marginTop: theme.spacing.unit * 3,
    })
});

class StandardDropDownSelector extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            option: props.shouldDefault ? props.defaultValue : ''
        }
    }



    handleChange = (event) => {
        this.setState({ option: event.target.value });
        this.props.handleSelection(event.target.value);

    };


    generateMenuItems() {
        let _this =this;
        return this.props.optionsList.map(function (optionText, index) {

            return (
                <MenuItem name={optionText} key={_this.props.menuId+'-'+optionText + '-menuOption'} value={index}>
                    <span style={_this.props.showMobile ?  mobileStandardDropdownMenuItemStyle : desktopStandardDropdownMenuItemStyle}>{optionText}</span>
                </MenuItem>)
        })
    }

    render() {
        const { classes, showMobile, menuId } = this.props;
        return (
            <FormControl key={menuId+'-form-control'} id={menuId+'-form-control'} className={classes.formControl} style={showMobile ?  mobileStandardDropdownStyle : desktopStandardDropdownStyle}>

                <Select key={menuId+'-select'} id={menuId+'-select'} 
                    value={this.state.option}
                    onChange={this.handleChange}

                >
                    
                    {this.generateMenuItems()}
                </Select>
            </FormControl>


        )
    }
}

export default withStyles(styles)(StandardDropDownSelector);


// WEBPACK FOOTER //
// ./src/components/common/dropdowns/standard/StandardDropDownSelector.js